import styled, { CSSObject } from 'styled-components';

import { EActionAttribute, EColor, EFontWeight, ThemeProps } from '@core/type';
import { getPaletteHandlers } from '@core/util';

import { Box } from '../layout';
import { LinkTranslatedStyledAsButton } from '../link-translated';
import { LinkTranslatedStyledAsButtonProps } from '../link-translated/interface-link-translated';
import { PaginationLinkProps } from './interface-pagination';

export const PaginationLink = ({
  children,
  query,
  isActive,
  keyRoute,
  onClick,
  page,
}: PaginationLinkProps) => (
  <Box as={EActionAttribute.LI} listStyleType={'none'}>
    <StyledPaginationLink
      query={query}
      keyRoute={keyRoute}
      onClick={onClick}
      isActive={isActive}
      as={EActionAttribute.LINK}
      aria-label={`pagination-link page-${page}`}
      aria-current={isActive}
    >
      {children}
    </StyledPaginationLink>
  </Box>
);

type Props = LinkTranslatedStyledAsButtonProps & {
  isActive?: boolean;
  theme: ThemeProps;
};

const StyledPaginationLink = styled(LinkTranslatedStyledAsButton)<Props>(({
  theme: {
    typography: { fontWeight: fontWeightVariants },
    palette,
  },
  isActive,
  ...restProps
}: Props) => {
  const { getTextColor, getBackgroundColor } = getPaletteHandlers(palette);
  const color = getTextColor(
    isActive ? { commonType: EColor.WHITE, intensity: EColor.R900 } : EColor.PRIMARY,
  );
  const backgroundColor = getBackgroundColor(
    isActive ? EColor.PRIMARY : { semanticType: EColor.NEUTRAL, variant: EColor.LIGHT },
  );

  return {
    cursor: isActive ? 'auto' : 'pointer',
    borderRadius: '50%',
    height: 28,
    width: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '15px',
    fontWeight: fontWeightVariants[EFontWeight.MEDIUM],
    color,
    backgroundColor,
    padding: 0,
    border: 'none',
    transition: 'none',
    ...restProps,
  } as CSSObject;
});
